/**
 * Build a ZIP in the browser by streaming each file from signed URLs.
 * Avoids Edge Function memory/time limits for large albums.
 */
import { downloadZip } from 'client-zip';

/** Avoid path traversal / duplicate names inside the archive */
export function deliveryZipEntryName(originalName, index) {
  const base = String(originalName || 'file').replace(/[/\\]/g, '_');
  return `${String(index + 1).padStart(4, '0')}_${base}`;
}

/**
 * @param {Array<{ file_name: string; signed_url: string; file_size_bytes?: number }>} items
 * @param {(p: { current: number; total: number; label: string }) => void} [onProgress]
 * @returns {Promise<Blob>}
 */
export async function buildDeliveryZipBlob(items, onProgress) {
  if (!items?.length) {
    throw new Error('لا توجد ملفات للتحميل');
  }

  async function* streamFiles() {
    const total = items.length;
    for (let i = 0; i < total; i++) {
      const item = items[i];
      onProgress?.({
        current: i + 1,
        total,
        label: `جاري تحميل الملف ${i + 1} من ${total}…`,
      });

      const res = await fetch(item.signed_url);
      if (!res.ok) {
        throw new Error(`فشل تحميل: ${item.file_name || 'ملف'}`);
      }

      const headerLen = res.headers.get('content-length');
      const size =
        typeof item.file_size_bytes === 'number' && item.file_size_bytes > 0
          ? item.file_size_bytes
          : headerLen
            ? parseInt(headerLen, 10)
            : undefined;

      yield {
        name: deliveryZipEntryName(item.file_name, i),
        input: res,
        ...(size != null ? { size } : {}),
        lastModified: new Date(),
      };
    }
  }

  const zipResponse = downloadZip(streamFiles());
  return zipResponse.blob();
}
